export default "/images/image_7.jpg?d460b319de40fd1f7dec987b98db226c";